import { ReactNode, useMemo } from 'react';
import { Widget } from 'jamespot-front-business';

import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import styled from 'styled-components';

export const UIWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const WidgetStylePadding = ({ uniqid, children }: { uniqid: string; children: ReactNode }) => {
    const styles = useAppSelector((state) => Widget.selectors.selectWidgetWrapperStyle(state, uniqid), shallowEqual);

    const initialValues = useMemo(() => {
        return {
            padding: styles && styles['padding'] ? `${styles['padding']}px` : '0px',
        };
    }, [styles]);

    return <UIWrapper style={{ padding: initialValues.padding }}>{children}</UIWrapper>;
};
